import { WalletBase } from '../WalletBase';
import { ISignResult } from '../types';

const paymentType = 'p2wpkh'; // p2wpkh or p2tr

// https://hirowallet.gitbook.io/developers/bitcoin/connect-users/get-addresses
export class BitcoinWallet extends WalletBase {
  authType = 'Leather';
  app?: {
    name: string;
    icon: string;
  };

  init(): void {
    if ('btc' in window) {
      const provider = window.btc;

      this.provider = provider;
    } else {
      window.open('https://leather.io/', `_blank`);
    }
  }
  async connect(): Promise<boolean> {
    const provider = this.provider;
    if (!provider) return false;
    const userAddresses = await provider?.request('getAddresses');
    const usersNativeSegwitAddress = userAddresses.result.addresses?.find(
      (address: any) => address.type === paymentType
    );
    this.isConnected = true;

    this.address = usersNativeSegwitAddress?.address;
    this.publicKey = usersNativeSegwitAddress?.publicKey;
    return true;
  }

  async sign(message: string): Promise<ISignResult> {
    const response = await this.provider?.request('signMessage', {
      message,
      paymentType: paymentType
    });
    console.log(response);
    return {
      message,
      signature: response.result.signature
    };
  }
}
